import { createContext, useState } from 'react';
import API from 'services/api';
// import _ from "lodash"

export const ReportContext = createContext({});

const ReportProvider = props => {
	const [markbooks, setMarkbooks] = useState([]);
	const [oaLists, setOALists] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const [pagination, setPagination] = useState({
		currentPag: 0,
		totalPages: 0,
		totalResult: 0,
	});

	const [fyear, setFyear] = useState(null);
	const [fdateExp, setFdateExp] = useState(null);
	const [fdate, setFdate] = useState(null);
	const [fsearch, setFSearch] = useState(null);
	const [fassociate, setFassociate] = useState(null);

	const resetFilter = () => {
		// setFyear(null)
		setFdateExp(null);
		setFdate(null);
		setFSearch(null);
		setFassociate(null);
	};

	const getMarkBook = params => {
		return API.getMarkBook(params)
			.then(res => {
				const { data } = res;
				// setMarkbooks(data)

				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getMarkBookLimit = params => {
		return API.getMarkBookLimit(params)
			.then(res => {
				const { data } = res;
				let result = data?.data;
				console.log('get data', result);
				let pagination = data?.pagination;
				setMarkbooks(result);
				setPagination(pagination);

				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getReportSearch = params => {
		return API.getReportSearch(params)
			.then(res => {
				const { data } = res;
				setMarkbooks(data);

				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getReportOA = params => {
		return API.getReportOA(params)
			.then(res => {
				const { data } = res;
				setMarkbooks(data);
				setOALists(data);

				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	const getReportLegal = params => {
		return API.getReportLegal(params)
			.then(res => {
				const { data } = res;
				setMarkbooks(data);
				setOALists(data);

				return data;
			})
			.catch(err => {
				throw err;
			});
	};

	return (
		<ReportContext.Provider
			value={{
				markbooks,
				oaLists,
				isLoading,
				setLoading,

				getMarkBook,
				getReportSearch,
				getReportOA,
				getReportLegal,

				pagination,
				getMarkBookLimit,

				fyear,
				fdateExp,
				fdate,
				fsearch,

				setFyear,
				setFdateExp,
				setFdate,
				setFSearch,

				fassociate,
				setFassociate,

				resetFilter,
			}}
			{...props}
		/>
	);
};

export default ReportProvider;
